import { Controller } from "@hotwired/stimulus"

// Real Estate staging-tier toggle: standard "Real Estate" vs curated
// "Real Estate +". Shows the matching style picker and clears the other
// tier's selected style so a stale cross-tier architectural_style is never
// submitted (e.g. a standard br_01 left checked while RE+ is active).
export default class extends Controller {
  static targets = ["tierInput", "standardBlock", "plusBlock"]

  connect() {
    this.switch()
  }

  switch() {
    const plus = this.isPlus()
    if (this.hasStandardBlockTarget) this.standardBlockTarget.hidden = plus
    if (this.hasPlusBlockTarget) this.plusBlockTarget.hidden = !plus
    this.clearHiddenTierSelection(plus)
  }

  isPlus() {
    const checked = this.tierInputTargets.find((el) => el.checked)
    return checked ? checked.value === "true" : false
  }

  // When a tier is hidden, uncheck any style radio inside it so the form
  // submits only a style that belongs to the active tier.
  clearHiddenTierSelection(plus) {
    const hidden = plus
      ? (this.hasStandardBlockTarget ? this.standardBlockTarget : null)
      : (this.hasPlusBlockTarget ? this.plusBlockTarget : null)
    if (!hidden) return
    hidden.querySelectorAll("input.style-radio:checked").forEach((el) => {
      el.checked = false
    })
  }
}
